import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateTextPostMutation = createMutationHook(
  MembershipsCreatorApiClient.updateTextPost,
  {
    mutationKey: ['updateTextPost'],
  },
)
